import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'toPicklist',
    pure: false
})

export class ToPicklistPipe implements PipeTransform {
    transform(value: any, table: any) {
        let result: string = "";
        if (table != undefined) {
            table.forEach(element => {
                if (value == element.key) {
                    result = element.text;
                }
            });
        }
        return result;
    }
}